import { Component, OnInit } from '@angular/core';

import { SimpleComponent } from '../../common/simple.component';

@Component({
	selector: 'app-bank-transactions-names',
	templateUrl: './bank-transactions-names.component.html',
	styleUrls: ['./bank-transactions-names.component.css'],
})
export class BankTransactionsNamesComponent extends SimpleComponent {
	protected apiUrl = 'bankTransactionsNames';
	protected itemsBeforeDataLoad = 1;
	elements: Array<BankTransactionsNames> = [];
	data: BankTransactionsNames = {
		id: null,
		name: null,
		type: null,
		typeName: null,
		operation: null,
		operationName: null,
	};
	tableRows = [
		{ id: 'name', name: 'Nazwa' },
		{ id: 'operationName', name: 'Operacja' },
		{ id: 'typeName', name: 'Rodzaj' },
	];
	types: Array<any> = [];
	operations: Array<any> = [
		{
			id: 'equals',
			name: 'Jest równe',
		},
		{
			id: 'startedwith',
			name: 'Zaczyna się od',
		},
	];

	protected resetData(): void {
		this.data = {
			id: null,
			name: '',
			type: null,
			typeName: null,
			operation: null,
			operationName: null,
		};
	}

	protected loadBefore() {
		this.api.get('/bankTransactionsTypes/', (result, error) => {
			this.types = result.data;
			this.loadData();
		});
	}

	protected convertData(data) {
		data.forEach((element) => {
			const type = this.types.find((obj) => obj.id == element.type);
			element.typeName = type.name;
			const operation = this.operations.find((obj) => obj.id == element.operation);
			element.operationName = operation.name;
		});
		return data;
	}
}
export interface BankTransactionsNames {
	id: number;
	name: string;
	type: number;
	typeName: number;
	operation: string;
	operationName: string;
}
